import { render } from "./NuovoRapportinoAppuntamento.vue?vue&type=template&id=dc583d00&scoped=true"
import script from "./NuovoRapportinoAppuntamento.vue?vue&type=script&lang=js"
export * from "./NuovoRapportinoAppuntamento.vue?vue&type=script&lang=js"

import "./NuovoRapportinoAppuntamento.vue?vue&type=style&index=0&id=dc583d00&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1769522087380908112/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc583d00"]])

export default __exports__